import type { Styles } from 'common/types';

export const styles: Styles = {
  addButton: {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 500,
    borderStyle: 'dashed',
    borderWidth: '2px',
    borderColor: 'primary.main',
    backgroundColor: '#f5faff',
    '&:hover': {
      backgroundColor: '#e3f2fd',
      borderStyle: 'dashed',
      borderWidth: '2px',
    },
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pb: 1,
  },
  dialogContent: {
    pt: 2,
    pb: 2,
    overflow: 'visible',
  },
  selectValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  selectValueIcon: {
    width: 20,
    height: 20,
    objectFit: 'contain',
    flexShrink: 0,
  },
  menuItemBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
  menuItemIcon: {
    width: 22,
    height: 22,
    objectFit: 'contain',
  },
  searchIcon: {
    mr: 0.5,
    fontSize: 20,
    color: 'text.disabled',
  },
  errorText: {
    mt: 0.75,
    mx: 0,
    fontSize: '13px',
  },
  importLink: {
    display: 'inline-block',
    mt: 1,
    fontSize: '13px',
    color: 'primary.main',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  dialogActions: {
    px: 3,
    pb: 2.5,
    gap: 1,
  },
};
